// 配置本地测试
module.exports = {
  // 接口地址配置
  // baseURL: 'http://manageapi.sujiaofei.com',
  baseURL: 'http://manageapi.kuaijiaofei.com',
}



// WEBPACK FOOTER //
// ./src/config/prod.conf.js